export const ENV = {
    MODE: 'Test',
    VERSION: '0.9.99.62',
    FIREBASE_API_URL: 'https://us-central1-sentrex-navigator-test.cloudfunctions.net',
    TWILIO_SID: 'AC5097e657735ee8ee39d177ed1e7f1360',
    API_SECRET: 'dd4c6e15-647b-41e9-b8f0-6dc8d6bc5ba1',
    FIREBASE_CONFIG:{
        apiKey: "AIzaSyDAe0zSB5e-UoIPUrWe8NvNBqzbYvuS3as",
        authDomain: "sentrex-navigator-test.firebaseapp.com",
        databaseURL: "https://sentrex-navigator-test.firebaseio.com",
        projectId: "sentrex-navigator-test",
        storageBucket: "sentrex-navigator-test.appspot.com",
        messagingSenderId: "997414184025",
        appId: "1:997414184025:web:d9285bdc7e09ce7b"
    },
    // FIREBASE_CONFIG:{
    //     apiKey: "AIzaSyBTdijcuspcrKSvGAA6FlLC62TWTOMYbWI",
    //     authDomain: "navigator-24030.firebaseapp.com",
    //     databaseURL: "https://navigator-24030.firebaseio.com",
    //     projectId: "navigator-24030",
    //     storageBucket: "navigator-24030.appspot.com",
    //     messagingSenderId: "902604109446",
    //     appId: "1:902604109446:web:50e9e36ed4fcb019970307",
    //     measurementId: "G-KBVSD30JGQ"
    // },
    PROGRAM_ID: 'IZ6eRRgc9ShXGYe9OgpH',
    PROGRAM_NAME: 'Eisai Cares',
    order_drug_email_to: 'kent@spadzinski.com',
    order_drug_email_cc: '',
    order_drug_email_bcc: '',
    order_other_email_to: 'kent@spadzinski.com',
    order_other_email_cc: '',
    order_other_email_bcc: '',
    STI_CONFIG: {
        token_url: 'https://sso.sti.works/auth/realms/stiapi/protocol/openid-connect/token',
        token_url_prod: 'https://auth.smartsti.com/auth/realms/stiapi/protocol/openid-connect/token',
        api_url: 'https://pmvx.sti.works/services/patient/',
        api_url_prod: 'https://stiassist.com/services/patient/',
        grant_type: 'client_credentials',
        client_id: 'sentrex-api-client',
        client_secret: 'd889ba56-f50f-435f-9371-7fadfa2a7161',
        client_secret_prod: '5f2ce9a9-4c92-49d7-975a-f58050e1f77a'
    }
  }


// WEBPACK FOOTER //
// ./src/environments/environment.dev.ts